import React, { createContext } from "react";

const ListadoContext = createContext();

export default ListadoContext;
